'use client';
import { useSearchParams } from 'next/navigation';

/**
 * クライアント側でURLの `ver` パラメータを取得する
 */
export function useVerParam(): string | null {
  const searchParams = useSearchParams();
  const ver = searchParams.get('ver');
  return typeof ver === 'string' ? ver : null;
}
